import React from 'react';
import { withRouter } from 'react-router-dom';
import ToggleSortButton from 'components/ToggleSortButton';

import './styles.css';

class ListSortControls extends React.Component {
  constructor(props) {
    super(props);
    this.sortingFieldUpdate = this.sortingFieldUpdate.bind(this);
  }

  sortingFieldUpdate(value) {
    this.props.onSortByChangeHandler(value);
  }

  render() {
    const { sortBy } = this.props;

    return (
      <div className="list-sort-controls">
        <label className="list-sort-controls__label">
          {this.props.sortByLabel || 'Sort By:'}
        </label>
        <div className="list-sort-controls__togglers">
          {this.props.sortControls
            .filter(a => !a.hidden)
            .map((control, index) => {
              return (
                <ToggleSortButton
                  defaultClass="list-sort-controls__control"
                  toggledClass="list-sort-controls__control--selected"
                  defaultCaption={control.defaultCaption}
                  toggledCaption={control.toggledCaption}
                  value={control.value}
                  sortBy={sortBy}
                  sortingFieldUpdate={this.sortingFieldUpdate}
                  key={`${
                    typeof control.value === 'object'
                      ? JSON.stringify(control.value)
                      : control.value
                  }`}
                />
              );
            })}
        </div>
      </div>
    );
  }
}

export default withRouter(ListSortControls);
